import PropTypes from "prop-types";
import NoConnectionError from "./noConnectionError";

const Error = ({ isAppOnline, children }) => {
  if (!isAppOnline) {
    return <NoConnectionError />;
  }

  return children;
};

Error.propTypes = {
  isAppOnline: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default Error;
